import React, { useEffect, useState } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { MidTermForm } from './MidTermForm'
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG'
import { useAuth } from '../../auth/core/Auth' // Import useAuth for currentUser

type Props = {
  show: boolean
  handleClose: () => void
}

const MidTermModal: React.FC<Props> = ({ show, handleClose }) => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const { currentUser } = useAuth() // Get currentUser from useAuth

  useEffect(() => {
    if (show) {
      fetchData()
    }
  }, [show])

  const fetchData = async () => {
    setLoading(true)
    try {
      const payload = {
        EmployeeId: currentUser?.EmployeeId, // Use EmployeeId from currentUser
        CrmClientId: currentUser?.CRMClientId, // Use CrmClientId from currentUser
      }

      const response = await fetch('https://etl.futurisk.in/webhook/1f865821-e2ca-4964-872b-4de0e50b695e', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(currentUser?.sessioncode ? { SessionCode: currentUser.sessioncode } : {}),
        },
        body: JSON.stringify(payload),
      })
      const result = await response.json()
      setData(result.Id ? result : null)
    } catch (error) {
      console.error('Error fetching data:', error)
      setData(null)
    } finally {
      setLoading(false)
    }
  }

  const dissmissLocation = () => {
    handleClose()
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_test'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName=' modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Mid Term Addition</h5>
          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-3x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <p>Loading...</p>
          ) : data ? (


<div>
  {/* Instruction + Submitted Details Combined in One Styled Box */}
  <div style={{
    backgroundColor: '#fff8e1',
    border: '1px solid #fbc02d',
    padding: '16px 24px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    lineHeight: '1.6',
    borderRadius: '8px',
    marginBottom: '24px',
    color: '#333'
  }}>
        <ul style={{
      paddingLeft: '20px',
      margin: 0,
      listStyleType: 'disc',
      marginBottom: '16px'
    }}>
      <li style={{ marginBottom: '6px' }}>
      Midterm addition request is submitted on {new Date(data.DateTime).toLocaleDateString()}.<br />
Please note, These additions will be only be covered under your health insurance post confirmation by the HR team. <br />
For any queries or updates, please contact your account manager listed in the Help Centre on the dashboard.      
</li>
    </ul>
</div>
<div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Submitted details are as follows:</div>
    <p style={{ marginBottom: '6px' }}><strong>Name:</strong> {data.Name}</p>
    <p style={{ marginBottom: '6px' }}>
      <strong>Relation:</strong> {data.RelationId === 1 ? 'Child' : data.RelationId === 2 ? 'Spouse' : 'Other'}
    </p>
    <p style={{ marginBottom: '6px' }}><strong>Gender:</strong> {data.Gender}</p>
    <p style={{ marginBottom: '6px' }}>
      <strong>Date of Birth:</strong> {new Date(data.DateOfBirth).toLocaleDateString()}
    </p>
    {/* Add more fields as needed */}
  </div>

          ) : (
            <Row>
              <Col xs={12} md={12}>
                <MidTermForm />
              </Col>
            </Row>
          )}
        </div>
      </div>
    </Modal>
  )
}

export { MidTermModal }
